import React from "react";
import { isNil } from "lodash";
import styled from "styled-components";
import { shorten } from "@backpacker/number";
import { FontSize, FontWeight, Spacing, content } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import { tr } from "@radarly/i18n";
import { InfluencerAccountMetric } from "@radarly/models/influencer";

interface IProps {
  locale?: Locale;
  metrics: InfluencerAccountMetric[];
  className?: string;
}

const Root = styled.div`
  display: flex;
  justify-content: center;
  gap: ${Spacing.Jumbo};
  margin-top: ${Spacing.ExtraSmall};
`;

const Metric = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${Spacing.Micro};
`;

const MetricLabel = styled.p`
  font-weight: ${FontWeight.Bold};
  font-size: ${FontSize.Medium};
  text-align: center;
`;

const MetricValue = styled.p`
  color: ${(props) => content(props, "secondary")};
  font-size: ${FontSize.Medium};
  text-align: center;
`;

const RadarlyAccountMetrics = ({ locale, metrics, className }: IProps) => {
  return (
    <Root className={className}>
      {metrics
        .filter((metric) => !isNil(metric.value))
        .map((metric, index) => {
          return (
            <Metric key={`account_metric_${index}${metric.value}`}>
              <MetricLabel>
                {tr(locale, `PINNED_AUTHOR::ACCOUNT_METRIC::${metric.key}`)}
              </MetricLabel>
              <MetricValue>
                {metric.key === "COUNTRY"
                  ? tr(locale, "COUNTRIES::" + metric.value)
                  : shorten(locale, metric.value)}
              </MetricValue>
            </Metric>
          );
        })}
    </Root>
  );
};

export default RadarlyAccountMetrics;
